import React, { Component } from 'react'
import './styles/LocationLookup.css'

class LocationLookup extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    if(this.props.onClick) {
      this.props.onClick()
    }
    event.preventDefault()
  }

  render() {
    return (
      <div className="locationLookup">
        <button
          onClick={this.handleClick}
        >
          &#xE909;
        </button>
      </div>
    )
  }
}

export default LocationLookup



// WEBPACK FOOTER //
// ./src/components/LocationLookup.js